export default () => ({
  type: 'PING'
})



/** WEBPACK FOOTER **
 ** ./src/actions/ping.js
 **/